export const TinyVeg: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M34.1885 6.38443C35.8472 4.04193 37.295 2.59975 39.3777 1.78162C43.7757 0.0538099 47.1054 2.29615 49.7194 4.78756C52.3335 7.27897 56.14 3.23303 60.2893 4.20631C64.7111 5.2435 69.0186 9.29787 69.7485 16.749"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.02 6.43225C18.3141 4.55897 19.4794 7.72537 22.8642 7.23553C26.1317 6.76272 28.6891 2.05803 35.3806 8.08506C37.5828 10.0685 40.4188 7.20772 42.4958 8.65834C45.2902 10.6101 42.978 13.1538 45.7794 14.583"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1576 24.6245C8.10715 19.6552 8.44762 13.1528 10.8889 9.27734"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.2861 33.2346C42.1322 30.9192 42.1178 28.5293 40.6656 26.7075C38.6453 24.1731 35.3805 26.1565 35.2705 22.8507C35.1605 19.545 34.6098 16.68 30.4036 16.0112C26.9476 15.4618 23.248 11.1265 19.7247 12.4489C15.822 13.9135 16.2719 18.6879 13.6923 21.6262C11.2308 24.4301 8.01999 25.0178 6.67968 29.5725C5.24764 34.4384 11.6711 37.3593 10.9372 42.6029C9.94811 49.6678 13.3701 49.8685 18.718 54.2554C27.6733 61.6015 23.7094 75.5593 37.2525 78.8282"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.4477 61.5686C57.3285 54.8988 58.2268 51.9907 63.9346 47.4963C68.3495 44.0201 76.8537 39.5624 72.1559 30.3063C69.7682 25.6019 74.2621 23.3576 72.7431 19.2871C71.6052 16.2385 68.7188 17.2335 65.9926 15.1702C63.8612 13.5571 62.5727 10.2552 59.3835 10.6404C56.5207 10.986 56.5131 13.3926 53.5479 14.6958C50.9574 15.8344 45.6248 12.548 43.7485 16.6793C42.097 20.3157 46.0607 25.1641 43.7485 29.7921C40.959 35.3754 32.1181 41.1935 30.4035 55.1363C28.9943 66.5963 37.2523 78.8277 37.2523 78.8277H42.9777C42.9777 78.8277 49.7031 76.9971 53.9938 66.0205"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.4453 78.8282C40.4453 78.8282 41.2739 62.079 50.2577 48.1384C59.9341 33.1229 59.6772 22.8506 59.6772 22.8506"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.565 62.7855C43.565 62.7855 39.6747 54.9537 42.6475 45.5137"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.5137 42.6023C53.5137 42.6023 62.1363 38.0566 64.7788 34.6406"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.2907 59.3988C30.2907 59.3988 24.2018 37.7915 22.9751 25.0176"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7729 41.2525C25.7729 41.2525 29.0487 36.5877 31.61 31.9229"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2495 31.9229C17.2495 31.9229 22.0445 34.4205 24.4183 34.641"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
